import type { RoomDef } from '../../sim/types.ts';

/**
 * Room 4 — The Seed (brief §6).
 *
 * No new verb. Rooms 1-3 taught cast, air-cast, and destroy one at a time;
 * this room's lesson is the win condition itself, made literal in the
 * geometry: the Portal sits in plain sight along a flat, unobstructed
 * corridor - the direct walk there does nothing, because the Moonseed is not
 * on that path at all. It is one tile down, under a short Vine patch in the
 * floor that reads as ordinary floor until you look at it.
 *
 * Rooms 1's Sprite already taught that digging finds *optional* things. This
 * room escalates that: the *required* objective is found the same way, which
 * is the actual point - a player who has learned to be suspicious of a floor
 * that looks slightly different has learned something that pays off here for
 * real, not just for a bonus.
 *
 * SCAFFOLD CONTENT (brief §14), same as Rooms 1-3.
 */
export const theSeed: RoomDef = {
  id: '04-the-seed',
  name: 'The Seed',
  map: [
    '################',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#######~~#######',
    '################',
  ],
  spawn: { x: 3.5, y: 10 },
  portal: { tx: 14, ty: 9 },
  items: [
    { kind: 'lumen', tx: 5, ty: 9 },
    // Under the Vine patch at (7-8, 10). Destroy it (S + Space, facing the
    // patch) and fall one tile to reach it - the Portal alone will not clear
    // the room without this.
    { kind: 'moonseed', tx: 7, ty: 10, hidden: true },
  ],
  chimera: [],
};
